<template>
    <div id="task-edit-content" :key="'campaign-task-id-' + $route.params.taskId">

        <MetaDataComponent title="Challenge lösen"/>

        <!--TODO: refactor this in own modal component -->
        <div class="modal fade" id="submit-task-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <!-- This link is needed to programmatically close modal -->
                    <a href="#" style="display: none;" ref="close-modal-invisible" data-dismiss="modal">Schließen</a>
                    <div class="modal-body" style="padding: 4rem;">
                        <p class="text-center" v-if="!this.submitTaskRequest.loaded">
                            <span class="loading-spinner loading-spinner-big"></span><br/>
                        </p>

                        <p class="text-center" v-if="this.submitTaskRequest.error !== null">
                            <i class="dev-circle-x" style="color: #ee5253"></i><br/>
                        </p>
                        <p v-if="taskSubmitted">
                            <svg style="margin-bottom: 3rem; margin-top: 4rem;" class="checkmark"
                                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                                <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                            </svg>
                        </p>
                        <h3 class="text-center" style="margin-top: 0"
                            v-if="!this.taskSubmitted && !this.submitTaskRequest.error && !this.submitTaskRequest.loaded">
                            Stage wird
                            abgegeben...</h3>
                        <h3 class="text-center" style="margin-top: 0" v-else-if="this.taskSubmitted===true">Stage
                            erfolgreich abgegeben.</h3>
                        <h4 class="text-center" style="margin-top: 0"
                            v-else-if="this.submitTaskRequest.error !== null">
                            {{ this.submitTaskRequest.error }}</h4>
                    </div>
                    <div class="modal-footer" v-if="taskSubmitted === true">
                        <router-link v-if="nextStage !== null"
                                     :to="{ name: 'challenge-edit-view', params: { campaignId: $route.params.challengeId, taskId: nextStage }}">
                            <button type="button" class="btn btn-primary"
                                    data-dismiss="modal" @click="loadNextStage(nextStage)">
                                Zur nächsten Stage
                            </button>
                        </router-link>
                        <router-link v-if="nextStage === null && this.challenge.loaded"
                                     :to="{ name: 'challenge-details', params: { slug: this.challenge.challenge_data.slug }, query: { technology: challengeTechnology }}">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">
                                zur Challenge Übersicht
                            </button>
                        </router-link>
                        <router-link v-else :to="{ name: 'challenge-list'}">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">
                                Schließen
                            </button>
                        </router-link>
                    </div>
                    <div class="modal-footer"
                         v-if="this.submitTaskRequest.loaded && this.submitTaskRequest.error !== null">
                        <button type="button" class="btn btn-primary" data-dismiss="modal">Schließen</button>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="row editor" :class="{'blur':!provisionerRequest.apiData.workspace_url}"
                 style="overflow:hidden;">
                <div class="col-sm-8 editor-inner">
                    <div
                        v-if="challenge.loaded && provisionerRequest.loaded && !provisionerRequest.error && provisionerRequest.apiData.workspace_url"
                        style="padding: 0;">
                        <EditorNG ref="newEditor" v-if="isNewEditor() && fileRequest.loaded && !fileRequest.error"
                                 :code="fileRequest.apiData.content"
                                 :programmingLanguage="fileRequest.apiData.programmingLanguage.toLocaleLowerCase()"
                                 :workspaceUrl="provisionerRequest.apiData.workspace_url"
                                 :filePath="filesRequest.apiData.files[0]">
                        </EditorNG>
                        <EditorX v-if="!isNewEditor() && fileRequest.loaded && !fileRequest.error"
                                 :code="fileRequest.apiData.content"
                                 :programmingLanguage="fileRequest.apiData.programmingLanguage.toLocaleLowerCase()"
                                 :workspaceUrl="provisionerRequest.apiData.workspace_url"
                                 :filePath="filesRequest.apiData.files[0]">
                        </EditorX>
                        <div v-if="!fileRequest.loaded" style="width: 800px; height: 600px" v-bind:style="currentStyle">
                            <div v-if="true" class="editor-loading-overlay">
                                <p class="text-center loading">
                                    <span class="loading-spinner loading-spinner-big loading-spinner-green"></span>
                                </p>
                            </div>
                        </div>
                        <!-- console output button -->
                        <div class="console_toggle" v-if="!this.consoleVisible" @click="consoleVisible=true"
                             style="position: absolute; bottom: -4rem; left: 0; width: 100%; height: 4rem; padding: 12px; background: #fafafa; color: black; border-top: 1px solid #dadada; border-bottom: 1px solid #dadada;">
                            <p style="width: 15rem; color:black; display: inline-block">&nbsp;<i
                                class="dev-terminal">&nbsp;&nbsp;</i>
                                Output</p>
                            <a href="#" class="text-right pull-right"
                               style="display: inline-block; color: black; padding-right: 5px;"><i
                                class="dev-chevron-up"
                                @click="this.consoleVisible=true"
                                style="" aria-hidden="true"></i></a>
                        </div>
                        <!-- console output -->
                        <div class="console-window" v-if="consoleVisible"
                             style="">
                            <div class="console_header" @click="consoleVisible=false"
                                 style="width: 100%; height: 4rem; padding: 12px; background: #fafafa; color: black; border-top: 1px solid #dadada; border-bottom: 1px solid #dadada;">
                                <p style="width: 15rem; color:black; display: inline-block">&nbsp;<i
                                    class="dev-terminal">&nbsp;&nbsp;</i>
                                    Output</p>
                                <div class="pull-right text-right">
                                    <a href="#" style="z-index: 90;" @click.stop="copyToClipboard()">
                                        <i class="dev-clipboard" style="margin-right: 10px;" title="In Zwischenablage kopieren"></i>
                                    </a>
                                    <a href="#"
                                       style="display: inline-block; color: black; padding-right: 5px;"><i
                                        class="dev-chevron-down"
                                        @click="consoleVisible=false"
                                        style="" aria-hidden="true"></i></a>
                                </div>
                            </div>
                            <pre class="consoleContent"
                                 style="overflow-x: auto; overflow-y: auto; height: calc(100%); background: white; border: none; margin: 0; border-radius: 0;">{{
                                    this.consoleContent
                                }}</pre>
                        </div>
                        <input type="hidden" ref="consoleContentInput" :value="this.consoleContent">
                        <!-- console output end -->
                    </div>
                    <div v-else style="height: 100vh;"></div>
                </div>
                <div id="flow-tests-component" class="col-sm-4 flow-tests">
                    <div v-if="!fileRequest.loaded" style="margin-top: 5rem">
                        <p class="text-center"><span class="loading-spinner loading-spinner-green loading-spinner-big"></span>
                        </p>
                        <h3 class="text-center">Loading...</h3>
                    </div>
                    <FlowTestViewerX v-if="fileRequest.loaded && !fileRequest.error"
                                     :task="task"
                                     :campaign="challenge"
                                     :commit-hash-editor="actualCommitHash"
                                     :liveServerUrl="provisionerRequest.apiData.live_server_url"
                                     :liveStreamCodeUrl="provisionerRequest.apiData.live_stream_code_url"
                                     :language=fileRequest.apiData.programmingLanguage.toLocaleLowerCase()
                                     :fileList="fileList"
                                     :isNewEditor="isNewEditor()">
                    </FlowTestViewerX>
                </div>
            </div>
                <div v-show="!hideSplashScreen"
                     class="splash"
                     :class="{'splashDismiss': startHideSplashAnimation, 'show-in-front': !hideSplashScreen && showLoading }">
                    <div class="splash-content">
                        <img v-if="!this.$features.WHITELABEL" :src="'/assets/img/logo_animation.svg?'+ $route.params.taskId"
                             class="splash-animation"
                             alt="polylith Logo"/>
                        <h3 style="margin-top: 2rem;" class="slash-text">
                            <span class="loading-spinner loading-spinner-medium loading-spinner-white"></span>&nbsp;&nbsp;<span id="loading-text">Dein Workspace wird gestartet...</span>
                        </h3>
                    </div>
                </div>
            <!-- interact -->
            <PreChallengeInteract @interactFinished="interactFinishedHandler()"
                                      :challenge="challenge"></PreChallengeInteract>
        </div>
    </div>
</template>

<script>
    import FlowTestViewerX from '../components/flow/FlowTestViewerX.vue';
    import EditorX from '../components/workspace/EditorX';
    import EditorNG from '../components/workspace/EditorNG';
    import {services, eventBus} from "../main";
    import 'jquery-ui-dist/jquery-ui.min.css';
    import 'jquery-ui-dist/jquery-ui.min.js';
    import 'jquery-ui-touch-punch/jquery.ui.touch-punch.min.js';
    import PreChallengeInteract from "../components/interacts/PreChallengeInteract";
    import {getTechnologyQuery, findGetParameter} from "../services/Utilities";

    export default {
        name: "ChallengeEditView",
        components: {
            PreChallengeInteract,
            EditorX,
            EditorNG,
            FlowTestViewerX
        },
        data() {
            return {
                challenge: services.taskManagementService.getChallengeDetails(this.$route.params.challengeId),
                provisionerRequest: services.provisioner.getWorkspaceUrl(this.$route.params.challengeId),
                changeFileRequest: {loaded: false, error: null},
                submitTaskRequest: {loaded: false, error: null},
                workspaceUrlLoaded: false,
                consoleVisible: false,
                consoleContent: "",
                timer: null,
                filesRequest: {loaded: false, error: null},
                fileRequest: {loaded: false, error: null},
                actualCommitHash: "",
                fileList: [],
                currentStyle: {width: "100%", height: "600px", "box-sizing": "border-box", margin: "6px auto"},
                runnTests: null,
                hideSplashScreen: false,
                startHideSplashAnimation: false,
                interactFinished: false,
                interactContentReady: false,
                startChallengeClicked: false,
                editorReady: false
            }
        },
        computed: {
            challengeRequestOrWorkspaceUrlOrInteractFinished() {
                return [this.challenge.loaded, this.interactFinished, this.workspaceUrlLoaded, this.editorReady];
            },
            isInteractChallenge() {
                return this.challenge.loaded && !this.challenge.error && this.challenge.challenge_data.selectedReward === 'WITHOUT_SPONSORING_AFTER_CONTACT';
            },
            task() {
                if (this.challenge.loaded) {
                    for (let task of this.challenge.challenge_data.tasks) {
                        if (task.task_id === this.$route.params.taskId) {
                            return task;
                        }
                    }
                }
            },
            taskSubmitted() {
                return this.submitTaskRequest.loaded && this.submitTaskRequest.error === null;
            },
            nextStage() {
                if (this.submitTaskRequest.loaded && this.submitTaskRequest.error === null) {
                    return this.submitTaskRequest.apiData.nextTaskId
                }
                return null;
            },
            challengeTechnology() {
                if (this.challenge.loaded) {
                    return getTechnologyQuery(this.challenge.challenge_data.technology);
                }
                return ""
            },
            showLoading() {
                return !this.challenge.loaded ||
                    !this.interactContentReady ||
                    !this.editorReady ||
                    this.startChallengeClicked && !this.interactFinished
            }
        },
        beforeUpdate() {
            if (!this.consoleVisible) {
                const $consoleWindow = $(".console-window");
                $consoleWindow.removeAttr('style');
                $consoleWindow.resizable("destroy");
            }
        },
        updated() {
            this.calculateStyle();
            this.resizeEditorAndTestContainer();
            if (this.consoleVisible) {
                const $console = $(".console-window");
                $console.resizable({
                    handles: 'n',
                });
                $console.on('resizestart', () => {
                    this.disablePointerEventsForEditor();
                });
                $console.on('resizestop', () => {
                    this.activatePointerEventsForEditor();
                });
            }
        },
        mounted() {
            // Trigger changing of loading messages
            setTimeout(function () {
                this.setLoadingMessage("Einen Moment noch...");
            }.bind(this), 28000);

            setTimeout(function () {
                this.setLoadingMessage("Gleich kannst du loslegen...")
            }.bind(this), 48000);

            setTimeout(function () {
                this.setLoadingMessage("Im Moment scheint viel los zu sein...")
            }.bind(this), 120000);

            setTimeout(function () {
                this.setLoadingMessage("Es dauert etwas länger als sonst...");
                if (!this.provisionerRequest.apiData.workspace_url) {
                    // Display warning to sentry
                    console.warn("Workspace did load longer than 4 Minutes...");
                }
            }.bind(this), 240000);

            eventBus.$on("consoleOutput", function (consoleOutput) {
                this.consoleContent = consoleOutput;
            }.bind(this));
            eventBus.$on("editorChangedContent", function ({fileContent}) {
                    if (this.provisionerRequest.loaded && this.provisionerRequest.apiData.workspace_url) {
                        this.fileList[0]["content"] = fileContent;
                        this.changeFileRequest = services.workspace.changeFileContent(
                            this.provisionerRequest.apiData.workspace_url,
                            this.$route.params.taskId,
                            this.filesRequest.apiData.files[0],
                            fileContent
                        )
                    }
                }.bind(this)
            );

            eventBus.$on("submitTask", function () {
                if (this.runnTests) {
                    this.runnTestsRequest = services.taskManagementService.runnTests(
                        this.runnTests.taskId,
                        this.runnTests.code
                    );
                }
                this.submitTaskRequest = services.taskManagementService.submitTask(
                    this.$route.params.taskId, this.actualCommitHash
                );
            }.bind(this));

            eventBus.$on("runnTests", function ({code}) {
                let runnTests = {
                    taskId: this.$route.params.taskId,
                    code: code
                };
                this.runnTests = runnTests;
                this.runnTestsRequest = services.taskManagementService.runnTests(
                    runnTests.taskId,
                    runnTests.code
                );
            }.bind(this));
            eventBus.$on("pre-challenge-content-ready", () => {
                // content in iframe is loaded
                this.interactContentReady = true;
            })
            eventBus.$on("interact-submit-start", () => {
                this.startChallengeClicked = true
            })
            eventBus.$on("editorReady", () => {
                this.editorReady = true;
            })
        },
        beforeDestroy() {
            // remove darkmode
            document.documentElement.removeAttribute('theme');
        },
        watch: {
            "challengeRequestOrWorkspaceUrlOrInteractFinished": function () {
                let errorWhileChallengeLoading = this.workspaceUrlLoaded && this.challenge.loaded && this.challenge.error;
                let workspaceIsLoadedAndNoInteractChallenge = this.workspaceUrlLoaded && this.editorReady && this.challenge.loaded && !this.challenge.error && !this.isInteractChallenge;
                let workspaceLoadedAndInteractFinished = this.workspaceUrlLoaded && this.editorReady && this.challenge.loaded && !this.challenge.error && this.isInteractChallenge && this.interactFinished;
                if (errorWhileChallengeLoading || workspaceIsLoadedAndNoInteractChallenge || workspaceLoadedAndInteractFinished) {
                    this.hideLoadingScreen();
                }
            },
            "runnTestsRequest.loaded": function () {
                if (!this.runnTestsRequest.loaded || this.runnTestsRequest.error) {
                    return;
                }
                this.runnTests = null;
            },
            "provisionerRequest.loaded": function () {
                if (this.provisionerRequest.error) {
                    let this_ = this;
                    this.timer = setTimeout(function () {
                        this_.provisionerRequest = services.provisioner.getWorkspaceUrl(this_.$route.params.challengeId);
                    }, 3000);
                }
                if (this.provisionerRequest.loaded && !this.provisionerRequest.error) {
                    clearTimeout(this.timer);
                    this.workspaceUrlLoaded = true;
                    this.filesRequest = services.workspace.getFiles(
                        this.provisionerRequest.apiData.workspace_url,
                        this.$route.params.taskId
                    );
                    this.registerKeepWorkspaceAlivePolling();
                }
            },
            "filesRequest.loaded": function () {
                let this_ = this;
                if (this.filesRequest.loaded && !this.filesRequest.error) {
                    // TODO change workspace api so it returns the planned fileList format
                    let filePath = this.filesRequest.apiData.files[0];
                    this.fileRequest = services.workspace.getFileContent(
                        this.provisionerRequest.apiData.workspace_url,
                        this.$route.params.taskId,
                        filePath,
                    )
                }
                if (this.filesRequest.error) {
                    setTimeout(function () {
                        this_.filesRequest = services.workspace.getFiles(
                            this_.provisionerRequest.apiData.workspace_url,
                            this_.$route.params.taskId
                        );
                    }, 3000)
                }
            },
            "fileRequest.loaded": function () {
                if (this.fileRequest.loaded && !this.fileRequest.error) {
                    //TODO: make this work for multiple editable files
                    this.fileList = [{
                        filePath: this.filesRequest.apiData.files[0],
                        content: this.fileRequest.apiData.content,
                        programmingLanguage: this.fileRequest.apiData.programmingLanguage.toLocaleLowerCase()
                    }];
                    this.actualCommitHash = this.fileRequest.apiData.commitHash;
                }
            },
            "changeFileRequest.loaded": function () {
                if (this.changeFileRequest.loaded && !this.changeFileRequest.error) {
                    this.actualCommitHash = this.changeFileRequest.apiData.commitHash;
                }
            },
            "submitTaskRequest.loaded": function () {
              if (this.submitTaskRequest.loaded && this.submitTaskRequest.error === null) {
                if (this.nextStage === null && this.challenge.loaded) {
                  this.$refs["close-modal-invisible"].click();
                  this.$router.push({
                    name: 'challenge-details',
                    params: {slug: this.challenge.challenge_data.slug},
                    query: {technology: this.challengeTechnology}
                  })
                }
              }
            },
        },
        methods: {
            // needed for new editor so drag and drop is working fine
            disablePointerEventsForEditor() {
                if (this.$refs.newEditor) {
                    this.$refs.newEditor.$el.style.pointerEvents = "none";
                }
            },
            activatePointerEventsForEditor() {
                if (this.$refs.newEditor) {
                    // change style of ref
                    this.$refs.newEditor.$el.style.pointerEvents = "auto";
                }
            },
            isNewEditor() {
              if(this.challenge.challenge_data.newEditor) {
                return true;
              }
              return findGetParameter("editorv2") !== null || window.ENABLE_NEW_EDITOR;
            },
            hideLoadingScreen() {
                this.startHideSplashAnimation = true;
                setTimeout(() => {
                    this.hideSplashScreen = true;
                }, 3000);
            },
            interactFinishedHandler() {
                this.interactFinished = true;
            },
            registerKeepWorkspaceAlivePolling: function () {
                this.keepWorkspaceAlivePolling = this.getKeepWorkspaceAliveTimeoutAndRenewIt();
            },
            getKeepWorkspaceAliveTimeoutAndRenewIt() {
                return setTimeout(function () {
                    // send request every window.WORKSPACE_KEEP_ALIVE_TIME_IN_MINUTES minutes to keep the workspace alive
                    services.workspace.setActive(this.provisionerRequest.apiData.workspace_url);
                    this.registerKeepWorkspaceAlivePolling();
                }.bind(this), parseInt(window.WORKSPACE_KEEP_ALIVE_TIME_IN_MINUTES) * 60 * 1000);
            },
            resizeEditorAndTestContainer: function () {
                let container = $(".editor");
                let $editor = $(".editor-inner");
                let $flowTestViewer = $("#flow-tests-component");
                let toggledFromSmall;
                window.addEventListener('resize', function () {
                    if ($(window).width() < 768) {
                        $editor.css('width', 100 + '%');
                        $editor.resizable('disable');
                        $flowTestViewer.width(100 + '%');
                        toggledFromSmall = true;
                    }
                    if ($(window).width() > 768) {
                        if (toggledFromSmall === true) {
                            toggledFromSmall = false;
                            $editor.css('width', 50 + '%');
                            $editor.resizable('enable');
                            $flowTestViewer.css('width', 50 + '%');
                        }
                    }
                });
                let sibTotalWidth;
                let this_ = this;
                $editor.resizable({
                    handles: 'e',
                    start: function (event, ui) {
                        sibTotalWidth = ui.originalSize.width + ui.originalElement.next().outerWidth();
                    },
                    stop: function (event, ui) {
                        let cellPercentWidth = 100 * ui.originalElement.outerWidth() / container.outerWidth();
                        let nextCell = ui.originalElement.next();
                        let nextPercentWidth = 100 * nextCell.outerWidth() / container.outerWidth();
                        if (nextPercentWidth + cellPercentWidth > 100) {
                            let diffrenceOverFullWidth = (nextPercentWidth + cellPercentWidth) - 100;
                            if (nextPercentWidth > cellPercentWidth) {
                                nextPercentWidth = nextPercentWidth - diffrenceOverFullWidth;
                            } else {
                                cellPercentWidth = cellPercentWidth - diffrenceOverFullWidth;
                            }
                        } else if (nextPercentWidth + cellPercentWidth < 100) {
                            let diffrenceUnderFullWidth = 100 - (nextPercentWidth + cellPercentWidth);
                            nextPercentWidth = nextPercentWidth + diffrenceUnderFullWidth;
                        }

                        ui.originalElement.css('width', cellPercentWidth + '%');
                        nextCell.css('width', nextPercentWidth + '%');
                    },
                    resize: function (event, ui) {
                        let renderHelperWidth = 10;
                        if (this_.isFirefoxClient()) {
                            renderHelperWidth = 25;
                        }
                        ui.originalElement.next().width(sibTotalWidth - ui.size.width - renderHelperWidth);
                        window.dispatchEvent(new Event("resize"));
                    },
                });
                $editor.on('resizestart', () => {
                    this.disablePointerEventsForEditor();
                });
                $editor.on('resizestop', () => {
                    this.activatePointerEventsForEditor();
                });
            },
            getTabName: (filePath) => {
                return filePath.replace(/^.*[\\\/]/, '')
            },
            setLoadingMessage(text) {

                let $loadingText = $("#loading-text");
                $loadingText.fadeOut(1000);
                setTimeout(function () {
                    let $loadingText = $("#loading-text");
                    $loadingText.text(text);
                    $loadingText.fadeIn(1000);
                }, 1000)
            },
            isFirefoxClient: function () {
                return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            },
            calculateStyle() {
                // Get the window height browser independently
                let windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                // remove the header bar
                let navbar_height = 62;
                try {
                    navbar_height = document.getElementById('navbar_row').scrollHeight;
                } catch (err) {
                    console.warn(err);
                }

                windowHeight = windowHeight - navbar_height - 13;
                this.currentStyle.height = `${windowHeight}px`;
            },
            loadNextStage: function (nextStageId) {
                // reset data to default values
                this.changeFileRequest = {loaded: false, error: null};
                this.submitTaskRequest = {loaded: false, error: null};
                this.consoleContent = "";
                this.fileRequest = {loaded: false, error: null};
                this.actualCommitHash = "";
                this.fileList = [];
                $(".modal-backdrop").removeClass("modal-backdrop");

                // load new file content
                this.filesRequest = services.workspace.getFiles(
                    this.provisionerRequest.apiData.workspace_url,
                    nextStageId
                );
            },
            copyToClipboard: function(){
                if (!navigator.clipboard){
                    let consoleContentElement = this.$refs.consoleContentInput;
                    consoleContentElement.setAttribute('type', 'text');
                    consoleContentElement.select();
                    document.execCommand("copy");
                    consoleContentElement.setAttribute('type', 'hidden');
                    return;
                }
                navigator.clipboard.writeText(this.consoleContent);

            }
        },
        destroyed() {
            clearTimeout(this.keepWorkspaceAlivePolling);
            clearTimeout(this.timer);
            eventBus.$off("consoleOutput");
            eventBus.$off("editorChangedContent");
            eventBus.$off("submitTask");
        },
    }
</script>

<style scoped>
/* animated checkmark */
.checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: #7ac142;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: block;
    stroke-width: 2;
    stroke: #fff;
    stroke-miterlimit: 10;
    margin: 10% auto;
    box-shadow: inset 0px 0px 0px #7ac142;
    animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
}

.checkmark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
}

@keyframes scale {
    0%, 100% {
        transform: none;
    }
    50% {
        transform: scale3d(1.1, 1.1, 1);
    }
}

@keyframes fill {
    100% {
        box-shadow: inset 0 0 0 30px #7ac142;
    }
}


#task-edit-content {
    background: #c4e3de;
}

.editor {
    transition: 2s;
}


.editor > .editor-inner {
    padding: 0;
    background: #fdfdfd;
    border-right: 1px solid #d1d1d1;
    opacity: 1;
}

.flow-tests {
    border-radius: 0;
    padding: 0;
    padding-left: 10px;
}

@keyframes loadingAnimation {
    0% {
        background-position: 0 50%;
    }
    100% {
        background-position: 100% 50%;
    }
}

.splash {
    margin-top: 61px;
    height: 100%;
    width: 100%;
    transition: width .4s cubic-bezier(0.39, 0.575, 0.565, 1);
    position: fixed;
    z-index: 80;
    right: 0;
    top: 0;
    background-size: 200%;
    background-image: linear-gradient(45deg, var(--sidebar-background), var(--main-color));
    background-position: center;
    overflow-x: hidden;
    animation: loadingAnimation 1s alternate infinite;
}

.splash.show-in-front {
    z-index: 100;
}

.wrapper.alt .splash {
  width: 100%;
}

.splash-white {
    background-image: none;
    background-color: white !important;
}

.splashDismiss {
    animation: loadingAnimation 45s alternate infinite, dismissSplashScreen 2.8s ease-in !important;
    opacity: 0;
}

.interact-screen {
    height: 100%;
    width: 100%;
    position: fixed;
    z-index: 89;
    left: 0;
    background-size: 500% 500%;
    background-position: 0 50%;
    opacity: 1;
    overflow-x: hidden;
    top: 0;
    animation: loadingAnimation 45s alternate infinite;
}


@keyframes dismissSplashScreen {
    0% {
        opacity: 0.9;
    }
    100% {
        opacity: 0;
        visibility: hidden;
    }
}


.splash-content {
    position: relative;
    top: 10%;
    width: 100%;
    text-align: center;
    margin-top: 100px;
}

.slash-text {
    position: absolute;
    width: 100%;
    text-align: center;
    color: white !important;
    margin-top: 30rem;
}

@keyframes window {
    0% {
        margin-left: 35px;
    }
    50% {
        margin-left: 45px;
    }
    100% {
        margin-left: 35px;
    }
}

.splash-animation {
    height: 30vh;
    width: auto;
}

#flow-tests-component {
    min-width: 20%;
}

@media (min-width: 768px) {
    .editor-inner {
        max-width: 80%;
    }

    .editor-inner .ui-resizable-handle.ui-resizable-e {
        cursor: ew-resize;
        background: url("/assets/img/dots.svg") no-repeat 50% 500%;
        right: -9px;
        background-size: 200% 100%;
    }

    .console-window .ui-resizable-handle.ui-resizable-n {
        cursor: ns-resize;
        background: #dadada url("/assets/img/dots_horizontal.svg") no-repeat 50% 50%;
        background-size: 200% 200%;
    }
}

@media only screen and (min-width: 1025px) {
    .splash {
        width: calc(100% - 240px);
    }
}

.console-window {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    min-height: 5rem;
    height: 20vh;
    background: white;
    border-radius: 0px;
}

.editor-loading-overlay {
    background-color: white;
    z-index: 9;
    position: absolute;
    height: 100%;
    width: 100%;
    transition: 0.2s;
}

.loading {
    position: absolute;
    top: 45%;
    width: 100%;
}

@keyframes delayedShow {
    99% {
        visibility: hidden;
    }
    100% {
        visibility: visible;
    }
}

</style>

